const ProductsMainSearch = class extends HTMLElement {
  constructor() {
    super();
    this.checkedProducts = [];
    this.selectedProductsBadges = document.querySelector('.selected-products-badges');
    this.selectedVariants = new Map();
    
    // Clicking close button
    this.querySelectorAll('.main-search__close').forEach((el) => {
      el.addEventListener('click', (evt) => {
        evt.preventDefault();
        document.body.classList.remove('show-search');
      });
    });

    // Pressing escape key
    this.querySelector('.main-search__input').addEventListener('keyup', (evt) => {
      if (evt.key === 'Escape') {
        this.querySelector('.main-search__close').dispatchEvent(new Event('click'));
      }
    });

    // Search as you type
    if (this.dataset.quickSearch === 'true') {
      this.initQuickSearch();
    }

    this.addEventListener('click', (evt) => {
      const productBlock = evt.target.closest('.product-block');
      if (productBlock) {
        evt.preventDefault();

        const isMultiVariant = !!productBlock.querySelector('.product-block-options--swatch');
        
        if (isMultiVariant) {
          this.handleMultiVariantClick(evt, productBlock);
        } else {
          this.handleMonoVariantClick(evt, productBlock);
        }
      }
    });
  }

  handleMultiVariantClick(evt, productBlock) {
    const variantItem = evt.target.closest('.product-block-options__item');
    if (variantItem) {
      const productId = productBlock.dataset.productId;
      const variantName = variantItem.dataset.optionItem;
      this.selectedVariants.set(productId, variantName);
      
      productBlock.querySelectorAll('.product-block-options__item').forEach(item => {
        item.classList.remove('selected-variant');
      });
      variantItem.classList.add('selected-variant');

      const quantitySelector = productBlock.querySelector('.quantity-selector');
      if (quantitySelector) {
        quantitySelector.classList.remove('disabled');
        
        // Update quantity display for the selected variant
        const existingProduct = this.checkedProducts.find(product => product.id === productId && product.variant === variantName);
        const quantityDisplay = quantitySelector.querySelector('.quantity-selector-display');
        quantityDisplay.textContent = existingProduct ? existingProduct.quantity : '0';
      }

      const promptMessage = productBlock.querySelector('.variant-prompt');
      if (promptMessage) {
        promptMessage.remove();
      }
    } else if (evt.target.classList.contains('quantity-selector-button')) {
      evt.preventDefault();
      const quantitySelector = evt.target.closest('.quantity-selector');
      if (quantitySelector.classList.contains('disabled')) {
        this.showVariantPrompt(productBlock);
      } else {
        const productId = productBlock.dataset.productId;
        const variantName = this.selectedVariants.get(productId);
        if (variantName) {
          this.handleQuantityChange(evt, productBlock, productId, variantName);
        }
      }
    }
  }
  
  showVariantPrompt(productBlock) {
    let promptMessage = productBlock.querySelector('.variant-prompt');
    if (!promptMessage) {
      promptMessage = document.createElement('div');
      promptMessage.className = 'variant-prompt';
      promptMessage.textContent = 'Please select a variant first.';
      const quantitySelector = productBlock.querySelector('.quantity-selector');
      const variantSelector =  productBlock.querySelector('.product-block-options');
      variantSelector.appendChild(promptMessage, quantitySelector.nextSibling);
    }
  }

  handleMonoVariantClick(evt, productBlock) {
    if (evt.target.classList.contains('quantity-selector-button')) {
      evt.preventDefault();
      const productId = productBlock.dataset.productId;
      const productTitle = productBlock.querySelector('.product-block__title').textContent;
      this.handleQuantityChange(evt, productBlock, productId, 'default', productTitle);
    }
  }

  handleQuantityChange(evt, productBlock, productId, variantName, productTitle) {
    const quantityDisplay = productBlock.querySelector('.quantity-selector-display');
    let quantity = parseInt(quantityDisplay.textContent, 10);
    
    if (evt.target.classList.contains('plus')) {
      quantity++;
    } else if (evt.target.classList.contains('minus')) {
      quantity = Math.max(0, quantity - 1);
    }
    
    quantityDisplay.textContent = quantity;
    this.updateCheckedProducts(productTitle || productBlock.querySelector('.product-block__title').textContent, productId, variantName, quantity);
  }

  updateQuantityDisplay(productBlock, productId, variantName) {
    const quantityDisplay = productBlock.querySelector('.quantity-selector-display');
    const existingProduct = this.checkedProducts.find(product => product.id === productId && product.variant === variantName);
    quantityDisplay.textContent = existingProduct ? existingProduct.quantity : '0';
  }

  updateCheckedProducts(productTitle, productId, variant, quantity) {
    const existingProductIndex = this.checkedProducts.findIndex(product => product.id === productId && product.variant === variant);
  
    if (quantity > 0) {
      if (existingProductIndex > -1) {
        this.checkedProducts[existingProductIndex].quantity = quantity;
      } else {
        this.checkedProducts.push({
          id: productId,
          title: productTitle,
          variant: variant,
          quantity: quantity
        });
      }
    } else {
      if (existingProductIndex > -1) {
        this.checkedProducts.splice(existingProductIndex, 1);
      }
    }
  
    this.updateSelectedProductsBadges();
    this.updateSelectedProductsInput();
  }

  updateSelectedProductsBadges() {
    if (this.selectedProductsBadges) {
      this.selectedProductsBadges.innerHTML = this.checkedProducts
        .map(product => {
          const variantText = product.variant === 'default' ? '' : ` - ${product.variant}`;
          
          return `
            <span class="selected-products-badge">
              <span class="product-title" style="margin: 0;">${product.title}${variantText}</span>
              <div class="quantity-selector summary-quantity-selector">
                <button class="quantity-selector-button minus">-</button>
                <span class="quantity-selector-display">${product.quantity}</span>
                <button class="quantity-selector-button plus">+</button>
              </div>
              <button class="remove-product-button">×</button>
            </span>
          `;
        })
        .join('');

      // Add event listeners for the new quantity selectors and remove buttons
      this.selectedProductsBadges.querySelectorAll('.summary-quantity-selector').forEach((selector, index) => {
        selector.addEventListener('click', (evt) => {
          if (evt.target.classList.contains('quantity-selector-button')) {
            const product = this.checkedProducts[index];
            const quantityDisplay = selector.querySelector('.quantity-selector-display');
            let quantity = parseInt(quantityDisplay.textContent, 10);

            if (evt.target.classList.contains('plus')) {
              quantity++;
            } else if (evt.target.classList.contains('minus')) {
              quantity = Math.max(0, quantity - 1);
            }

            this.updateProductQuantity(product, quantity);
          }
        });
      });

      this.selectedProductsBadges.querySelectorAll('.remove-product-button').forEach((button, index) => {
        button.addEventListener('click', () => {
          const product = this.checkedProducts[index];
          this.updateProductQuantity(product, 0);
        });
      });
    }
  }

  updateProductQuantity(product, newQuantity) {
    product.quantity = newQuantity;
    this.updateCheckedProducts(product.title, product.id, product.variant, newQuantity);
    
    // Update the quantity in the search results
    const productBlock = this.querySelector(`.product-block[data-product-id="${product.id}"]`);
    if (productBlock) {
      if (product.variant === 'default') {
        // For mono-variant products
        const quantityDisplay = productBlock.querySelector('.quantity-selector-display');
        if (quantityDisplay) {
          quantityDisplay.textContent = newQuantity;
        }
      } else {
        // For multi-variant products
        const variantOption = productBlock.querySelector(`.product-block-options__item[data-option-item="${product.variant}"]`);
        if (variantOption) {
          const quantitySelector = productBlock.querySelector('.quantity-selector');
          if (quantitySelector) {
            const quantityDisplay = quantitySelector.querySelector('.quantity-selector-display');
            if (quantityDisplay) {
              // Only update if this variant is currently selected
              if (variantOption.classList.contains('selected-variant')) {
                quantityDisplay.textContent = newQuantity;
              }
            }
          }
        }
      }
      
      // Update the selected variant if quantity is set to 0
      if (newQuantity === 0 && product.variant !== 'default') {
        const variantOption = productBlock.querySelector(`.product-block-options__item[data-option-item="${product.variant}"]`);
        if (variantOption) {
          variantOption.classList.remove('selected-variant');
          // If this was the selected variant, reset the quantity display
          if (variantOption.classList.contains('selected-variant')) {
            const quantitySelector = productBlock.querySelector('.quantity-selector');
            if (quantitySelector) {
              const quantityDisplay = quantitySelector.querySelector('.quantity-selector-display');
              if (quantityDisplay) {
                quantityDisplay.textContent = '0';
              }
            }
          }
        }
      }
    }
    
    // Refresh the summary badges
    this.updateSelectedProductsBadges();
    this.updateSelectedProductsInput();
  }

  updateSelectedProductsInput() {
    const selectedProductsInput = document.getElementById('selected_products_input');
    if (selectedProductsInput) {
      selectedProductsInput.value = this.checkedProducts
        .map(product => {
          const variantPart = product.variant && product.variant !== 'default' 
              ? ` - ${product.variant}` 
              : '';
          
          return `${product.title}${variantPart} : ${product.quantity}`;
        })
        .join(',');
    }
  }

  initQuickSearch() {
    const searchInput = this.querySelector('.main-search__input');
    const searchTimeoutThrottle = 500;
    const resultLimit = 10;
    const includeMeta = this.dataset.quickSearchMeta === 'true';
    let searchTimeoutID = -1;
    let searchAbortController = null;

    const handleInputChange = () => {
      const resultsBox = this.querySelector('.main-search__results');
      const valueToSearch = searchInput.value;

      // Only search if search string longer than 2, and it has changed
      if (valueToSearch.length && valueToSearch !== this.oldSearchValue) {
        // Save previous value
        this.oldSearchValue = valueToSearch;

        // Kill outstanding ajax request
        if (searchAbortController !== null) {
          searchAbortController.abort();
          searchAbortController = null;
        }

        // Kill previous search
        clearTimeout(searchTimeoutID);

        // Create URL for full search results
        const searchAction = this.dataset.searchAction || '/search';
        const linkURL = new URL(searchAction, window.location.origin);
        linkURL.searchParams.set('q', valueToSearch);

        // Show loading
        this.classList.remove('main-search--has-results', 'main-search--results-on-multiple-lines', 'main-search--no-results');
        this.classList.add('main-search--loading');
        if (!this.querySelector('.main-search__results-spinner')) {
          resultsBox.innerHTML = '<div class="main-search__results-spinner"><div class="loading-spinner"></div></div>';
        }

        // Do next search (in X milliseconds)
        searchTimeoutID = setTimeout(() => {
          searchAbortController = new AbortController();
          let ajaxUrl;

          if (theme.Shopify.features.predictiveSearch) {
            // use the API
            ajaxUrl = new URL(theme.routes.base + theme.routes.predictiveSearch);
            ajaxUrl.searchParams.set('q', valueToSearch);
            ajaxUrl.searchParams.set('section_id', 'predictive-search');
            ajaxUrl.searchParams.set('resources[limit]', resultLimit);
            ajaxUrl.searchParams.set('resources[options][fields]', includeMeta ? 'title,product_type,variants.title,vendor,tag,variants.sku' : 'title,product_type,variants.title,vendor');
          } else {
            // use the theme template fallback
            ajaxUrl = new URL(linkURL);
            ajaxUrl.searchParams.set('section_id', 'main-search');
          }

          fetch(ajaxUrl, { method: 'get', signal: searchAbortController.signal })
            .then((response) => {
              if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
              }
              return response.text();
            })
            .then((response) => {
              const template = document.createElement('template');
              template.innerHTML = response;
              let resultsList = null;
              if (theme.Shopify.features.predictiveSearch) {
                resultsList = template.content.querySelector('.product-grid');
              } else {
                resultsList = template.content.querySelector('.section-search-template .product-grid');
              }

              // reset previous contents
              searchAbortController = null;
              this.classList.remove('main-search--has-results', 'main-search--results-on-multiple-lines', 'main-search--no-results');
              resultsBox.innerHTML = '';

              const resultsProducts = document.createElement('div');
              resultsProducts.className = 'main-search__results__products collection-listing';
              resultsProducts.innerHTML = '<div></div>';

              resultsProducts.firstElementChild.className = resultsList.className;

              // Convert standard blocks into quick search result format
              resultsList.querySelectorAll('.product-block:not(.collection-block):not(.page-block)').forEach((block, index) => {
                if (index <= resultLimit) {
                  block.classList.add('main-search-result');
                  block.querySelectorAll('.btn.quickbuy-toggle').forEach((el) => el.remove());
                  block.querySelectorAll('.quickbuy-toggle').forEach((el) => el.classList.remove('quickbuy-toggle'));

                  const blockInnerInner = block.querySelector('.block-inner .block-inner-inner');

                  if (blockInnerInner) {    
                    const quantitySelector = document.createElement('div');
                    quantitySelector.className = 'quantity-selector';
                    quantitySelector.innerHTML = `
                      <button class="quantity-selector-button minus">-</button>
                      <span class="quantity-selector-display">0</span>
                      <button class="quantity-selector-button plus">+</button>
                    `;
                  
                    const quantityDisplay = quantitySelector.querySelector('.quantity-selector-display');
                    const productId = block.dataset.productId;
                    
                    const isMultiVariant = !!block.querySelector('.product-block-options--swatch');
                    if (isMultiVariant) {
                      quantitySelector.classList.add('disabled');
                    } else {
                      const existingProduct = this.checkedProducts.find(product => product.id === productId && product.variant === 'default');
                      if (existingProduct) {
                        quantityDisplay.textContent = existingProduct.quantity;
                      }
                    }
                  
                    blockInnerInner.appendChild(quantitySelector);
                  }

                  resultsProducts.firstElementChild.appendChild(block);
                }
              });

              this.classList.remove('main-search--loading');

              const areProducts = !!resultsProducts.querySelector('.main-search-result');
              if (areProducts) {
                // Numerous results
                this.classList.add('main-search--has-results');
                this.classList.toggle('main-search--results-on-multiple-lines', resultsProducts.querySelectorAll('.product-block').length > 4);
                if (areProducts) {
                  resultsBox.appendChild(resultsProducts);
                }
              } else {
                // No results - show nothing
                this.classList.add('main-search--no-results');
                const emptyMessage = document.createElement('div');
                emptyMessage.className = 'main-search__empty-message';
                emptyMessage.innerHTML = theme.strings.generalSearchNoResultsWithoutTerms;
                resultsBox.appendChild(emptyMessage);
              }
            });
        }, searchTimeoutThrottle);
      } else if (!valueToSearch.length) {
        // Abandon current search
        this.oldSearchValue = valueToSearch;
        if (searchAbortController !== null) {
          searchAbortController.abort();
          searchAbortController = null;
        }
        clearTimeout(searchTimeoutID);

        // Clear results
        this.classList.remove('main-search--has-results', 'main-search--results-on-multiple-lines', 'main-search--loading');
        resultsBox.innerHTML = '';
      }
    };

    searchInput.addEventListener('keyup', handleInputChange.bind(this));
    searchInput.addEventListener('change', handleInputChange.bind(this));
  }
};

window.customElements.define('products-main-search', ProductsMainSearch);